<template>
	<div>
		<v-row>
			<v-col class="py-0">
				<v-card outlined elevation="0" class="pt-2 rounded-lg">
					<v-col class="px-2 py-2 text-body-2 my-auto">
						<div class="text-center">
							<div class="pb-2">
								<v-img contain width="70" max-width="70px" class="border mx-auto rounded-circle" :src="profile.buyer_image ? profile.buyer_image : '/assets/icons/default-user.svg'"></v-img>
								<!-- <v-img width="70" height="70" class="border mx-auto rounded-circle" :src="'/assets/icons/default-user.svg'"></v-img> -->
							</div>
							<div class="text-caption">{{ profile.buyer_name }}</div>
							<div class="text-caption font-weight-bold">{{ profile.buyer_username }}</div>
						</div>
						<div class="py-5"><v-divider></v-divider></div>
						<div class="text-body-2 pt-5">
							<v-expansion-panels tile multiple accordion v-model="panel" class="accordion-filter accordion-profile">
								<v-expansion-panel>
									<v-expansion-panel-header class="text-uppercase font-weight-bold text-caption">Pesan</v-expansion-panel-header>
									<v-expansion-panel-content>
										<v-list class="py-0">
											<v-list-item dense class="px-0">
												<a href="/inbox" class="text-deco grey--text text--darken-1">
													<v-list-item-title class="text-caption">Pesan</v-list-item-title>
												</a>
											</v-list-item>
										</v-list>
									</v-expansion-panel-content>
								</v-expansion-panel>
								<v-expansion-panel>
									<v-expansion-panel-header class="text-uppercase font-weight-bold text-caption">Transaksi</v-expansion-panel-header>
									<v-expansion-panel-content>
										<v-list class="py-0">
											<v-list-item dense class="px-0">
												<a href="/transaction/list" class="text-deco grey--text text--darken-1">
													<v-list-item-title class="text-caption">Daftar Transaksi</v-list-item-title>
												</a>
											</v-list-item>
										</v-list>
									</v-expansion-panel-content>
								</v-expansion-panel>
								<v-expansion-panel>
									<v-expansion-panel-header class="text-uppercase font-weight-bold text-caption">Profile Saya</v-expansion-panel-header>
									<v-expansion-panel-content>
										<v-list class="py-0">
											<v-list-item dense class="px-0">
												<a href="/profile" class="text-deco grey--text text--darken-1">
													<v-list-item-title class="text-caption">Pengaturan</v-list-item-title>
												</a>
											</v-list-item>
										</v-list>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</div>
						<div class="pt-5 pb-2"><v-divider></v-divider></div>
						<v-btn block text color="pink" class="rounded-lg" @click="onLogout">
							<div class="pr-2 text-caption font-weight-bold">Keluar</div>
							<v-icon small>mdi-arrow-left-circle-outline</v-icon>
						</v-btn>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
	data () {
		return {
			store_slug: '',
			typePassword: 'password',
			iconPassword: 'mdi-eye',
			panel: [0,1,2],
			dialog: false,
			sponsor: '',
			upline: '',
			position_selected: '',
			identity_number: '',
			package_hu: 1,
			sponsor_name: '',
			upline_name: '',
			position_by: 'sponsor',
			type_member_option: [],
			list_bank_option: [],
			type_selected: {},
			bank_selected: '',
			bank_number: '',
			password: '',
			email: '',
			position_option: [{
				text: 'Sponsor',
				value: 'sponsor'
			}, {
				text: 'Upline',
				value: 'upline'
			}],
			position: [
			{
				text: 'Otomatis',
				value: ''
			}, {
				text: 'Kiri',
				value: 'L'
			}, {
				text: 'Kanan',
				value: 'R'
			}],
			ktp_error: '',
			sponsor_name_error: '',
			upline_name_error: '',
			member_type_error: '',
			package_hu_error: '',
			email_error: '',
			password_error: '',
			bank_error: '',
			bank_number_error: '',
			account_name: '',
			rulesTypeMember: [
			v => !!v || 'Tipe member tidak boleh kosong ',
			],
			rulesBank: [
			v => !!v || 'Bank tidak boleh kosong ',
			],
			rulesBanknumber: [
			v => !!v || 'Nomor Rekening tidak boleh kosong ',
			],
			rulesHU: [
			v => v <= 15 || 'Maksimal 15 HU',
			v => v >= 0 || 'Data tidak valid',
			],
			rulesPassword: [
			v => !!v || 'Password tidak boleh kosong',
			v => v.length > 5 || 'Data tidak valid',
			],
		}
	},
	computed: {
		...mapState('profile', ['profile', 'responseError']),
		...mapState('auth', ['userData']),

		rulesKTP() {
			let rules = []
			if (this.identity_number) {
				rules = [
				v => v.length == 16 || 'No. KTP tidak sesuai'
				]
			}
			return rules
		},
	},
	methods: {
		...mapActions('auth', ['logout']),
		...mapMutations(['makeAlert', 'progress']),
		...mapActions('profile', ['getProfile']),

		showPassword() {
			if (this.typePassword == 'password') {
				this.typePassword = 'text'
				this.iconPassword = 'mdi-eye-off'
			} else {
				this.typePassword = 'password'
				this.iconPassword = 'mdi-eye'
			}
		},
		onLogout() {
			this.logout().then( () => {
				if (this.$route.name && this.$route.name != 'home-store') {
					this.$router.push('/' + this.store_slug + '/')
				}
			})
		},
		gotoBukaToko() {
			this.$router.push({ name: 'buka-toko' })
		},
		gotoToko() {
			this.$router.push('/seller')
		},
		loginToMLM() {
			this.loginMLM().then(({ data }) => {
				window.open(data.url)
			})
		},
		async bukaProspek() {
			await this.getDataProspect()
			this.dialog = true
			this.email = await this.userData.buyer_email
			this.account_name = await this.userData.buyer_name
		},
		checkUserMLM(username, type) {
			if (username) {
				this.checkMLM({
					username: username
				}).then(( {data} ) => {
					if (type == 'sponsor') {
						this.sponsor_name = data.memberName
						this.sponsor_name_error = ''
					} else if (type == 'upline') {
						this.upline_name = data.memberName
						this.upline_name_error = ''
					}
				}).catch((err) => {
					this.makeAlert({ code: 'error_response', type: 'error', message: 'No. HP Upline/Sponsor tidak ditemukan', show: true })
					if (type == 'sponsor') {
						this.sponsor_name_error = "No. HP Sponsor " + err.message
						this.sponsor_name = ''
					} else if (type == 'upline') {
						this.upline_name_error = "No. HP Upline " + err.message
						this.upline_name = ''
					}
				})
			} else {
				if (type == 'sponsor') {
					this.sponsor_name = ''
					this.sponsor_name_error = ''
				} else if (type == 'upline') {
					this.upline_name = ''
					this.upline_name_error = ''
				}
			}
		},
		checkKTP() {
			this.checkKTPMember({
				identity_number: this.identity_number
			}).then(() => {
				this.ktp_error = ''
			}).catch((err) => {
				if (err.message == "error_validation") {
					this.ktp_error = err.data.identity_number
				}
			})
		},
		saveDataProspect() {
			let params = {
				member_identity_no: this.identity_number,
				network_sponsor_username: this.sponsor,
				position: this.position_by == 'sponsor' ? this.position_selected : '',
				network_upline_username: this.position_by == 'upline' ? this.upline : '',
				position_from_upline: this.position_by == 'upline' ? this.position_selected : '',
				member_type: this.type_selected.value,
				package_hu: this.package_hu,
				email: this.email,
				password: this.password,
				bank_id: this.bank_selected,
				bank_number: this.bank_number,
				bank_account_name: this.account_name,
			}
			this.package_hu_error = ''
			this.member_type_error = ''
			this.saveProspect(params).then(() => {
				this.dialog = false
			}).catch( () => {
				if (Object.values(this.responseError).length > 0) {
					this.package_hu_error = this.responseError.package_hu
					this.member_type_error = this.responseError.member_type
					this.email_error = this.responseError.email
					this.password_error = this.responseError.password
					this.bank_error = this.responseError.bank_id
					this.bank_number_error = this.responseError.bank_number
				} else {
					this.package_hu_error = ''
					this.member_type_error = ''
					this.email_error = ''
					this.password_error = ''
					this.bank_error = ''
					this.bank_number_error = ''
				}
			})
		},
		async validatePaste(val, ref) {
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					if (ref === true) {
						this.upline = ''
					} else {
						this.sponsor = ''
					}
				}
			})
		},
		getDataProspect() {
			this.getProspect().then( async ({ results }) => {
				this.position_by = 'sponsor'
				this.sponsor = await results.network_sponsor_username ;
				this.position_selected = await results.position_from_sponsor ;
				if (results.network_upline_username) {
					this.position_by = 'upline'
				}
				this.upline = await results.network_upline_username ;
				this.position_selected = await results.position_from_upline ;
				this.identity_number = await results.member_identity_no ;
				this.package_hu = await parseInt(results.package_hu) ;
				this.email = results.member_email
				this.password = ''
				this.bank_number = results.member_bank_account_no
				this.bank_selected = results.member_bank_id
				this.account_name = results.member_bank_account_name
				let selectedType = this.type_member_option.find(el => el.value == results.member_type)
				this.type_selected = selectedType ? selectedType : {}
			}).catch( (err) => {
				this.sponsor = this.userData.buyer_sponsor_buyer_username
				console.log(err)
			})
		}
	},
	created() {
		let store = localStorage.getItem('HwiEcomStore')
		this.store_slug = (store == undefined) ? '' : store
		this.getProfile()
		// this.type_selected.show_network = false
		// if (!(this.profile.buyer_network_id > 0)) {
		// 	this.getDataProspect()

		// 	this.getTypeMember().then( ({ results }) => {
		// 		this.type_member_option = results
		// 	})
		// 	this.getBankProspect().then( ({ results }) => {
		// 		this.list_bank_option = results
		// 	})
		// }
	}
};
</script>